import * as Phaser from "phaser-ce"
import { Sprites } from "../../../utils/Sprites"
import { MakeFriendAtlases } from "../MakeFriendAssets"
import { MakeFriendProgressStore } from "../MakeFriendProgressStore"


export enum CharacterType {
    YOU = "you",
    FRIEND = "friend",
    SMOKER = "smoker"
}

export enum CharacterFlavor {
    ONE = "ONE",
    TWO = "TWO",
    THREE = "THREE"
}

export enum CharacterContext {
    INTRO = "INTRO",
    ARCADE_OUTSIDE = "ARCADE_OUTSIDE",
    ARCADE_INSIDE = "ARCADE_INSIDE",
    POOL_IN = "POOL_IN",
    POOL_OUT = "POOL_OUT",
    SLEEPOVER_BEDROOM = "SLEEPOVER_BEDROOM",
    SLEEPOVER_OUTSIDE = "SLEEPOVER_OUTSIDE",
    SLEEPOVER_INSIDE = "SLEEPOVER_INSIDE",
    OUTRO = "OUTRO"
}

export class MakeFriendCharacter {

    static add = (
        game: Phaser.Game, type: CharacterType, flavor: CharacterFlavor, context: CharacterContext,
        {x = 0, y = 0, scale = 1, alpha = 1, group}:
            { x?: number, y?: number, scale?: number, alpha?: number, group?: Phaser.Group, debug?: boolean } = {}
    ) => {
        const genderRepresentation = MakeFriendProgressStore.isBoy() ? 'BOY' : 'GIRL'
        const typeRepresentation = type.toUpperCase()

        const key = `${ context }_${ typeRepresentation }_${ genderRepresentation }`
        const sprite = Sprites.add(game, MakeFriendAtlases[key], {scale, x, y, alpha, debug: true})
        switch (flavor) {
            case CharacterFlavor.ONE:
                sprite.frame = 0
                break
            case CharacterFlavor.TWO:
                sprite.frame = 1
                break
            case CharacterFlavor.THREE:
                sprite.frame = 2
                break
            default:
                sprite.frame = 0
        }

        group.add(sprite)

        return sprite
    }
}
